import { Button } from '@rocketmakers/armstrong';
import * as React from 'react';
import { useRoutePaths } from '../../../../shared/context/paths';
import { useBee } from '../../../../shared/hooks/useBee';
import { BackButton } from '../../components/buttons/back-button';
import { routePaths } from '../../routes';
import './complete.scss';

export const CompleteView: React.FunctionComponent = () => {
  const { beeInfo } = useBee();
  const { push } = useRoutePaths();
  const handleContinue = () => push(routePaths.home.root);

  return (
    <>
      <div>
        <BackButton />
        <h1>Installation Complete</h1>

        <div className="complete__container">
          <p className="complete__text">The BEE has successful been installed at</p>
          <div className="complete__address-container">
            <p data-qa="address-line-1" className="complete__address">
              {beeInfo?.bee?.physicalAddress?.addressLine1}
            </p>
            <p data-qa="address-city" className="complete__address">
              {beeInfo?.bee?.physicalAddress?.city}
            </p>
            <p data-qa="address-postcode" className="complete__address">
              {beeInfo?.bee?.physicalAddress?.postcode}
            </p>
          </div>
          <p className="complete__text">Press 'Finish' to return to the app.</p>
        </div>

        <Button data-qa="finish-button" className="btn-full btn-large complete__finish-button" onClick={handleContinue}>
          Finish
        </Button>
      </div>
    </>
  );
};
